<template>
    <div>
      <v-col cols="3" class="d-flex justify-begin mb-2">
      <v-btn class="mx-2 gris_medio" @click="exportToCSV">
                   {{$t('general.exportar')}}<span class="material-symbols-outlined">arrow_outward</span>
                </v-btn>
                <v-btn  class="mx-2 gris_medio" @click="importFromCSV">
                 <span class="material-symbols-outlined">arrow_insert</span>  {{$t('general.importar')}}
                  <input
                    type="file"
                    accept=".csv"
                    ref="fileInput"
                    style="display: none;"
                    @change="handleUpload"
                  />
                </v-btn>
              
              </v-col>
      <div class="contenedor-tabla">
      <div class="scroll-container">
        <table>
          <!-- <caption class="table-header">{{ $t('electricidad.precios_historicos_omie') }}</caption> -->
          <thead>
            <tr>
              <th class="encabezado_bold">{{ this.$t('electricidad.horizonte') }}</th>
              <th class="encabezado_bold">{{ this.$t('electricidad.hora') }}</th>
              <th class="encabezado_bold">{{ $t('electricidad.precio_omie_fmt') }}</th>
            </tr>
          </thead>
          <tbody v-if="precios_omie.length > 0">
            <tr v-for="(registro, index) in precios_omie" :key="index" class="tabla-hover">
              <td class="primera_columna">{{ registro.fecha_hora }}</td>
              <td class="primera_columna" style="text-align: center !important;">{{ registro.hora }}</td>
              <td>
                {{ (registro.valor !== null && registro.valor !== undefined) 
                      ? Number(registro.valor).toLocaleString('es-ES', { minimumFractionDigits: 2 }) 
                      : "" 
                }}
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="2">{{ $t("mensajes.precios_omie_no_disponible") }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    </div>
  </template>
  
  <script>
  import Papa from "papaparse";
  import Swal from "sweetalert2";

const HEADERS_OFICIALES_HIS = [
  "Horizonte",
  "Hora",
  "Precio casación OMIE (€/MWh)"
];
  export default {
    props: {
      precios_omie: {
        type: Array,
        required: true,
        default: () => [],
      }
    },
    mounted() {
    // Llamar automáticamente a la función al abrir la pestaña
    this.descargarDatos();
  },
    methods: {
      formatSigned(v) {
    const n = typeof v === 'number' ? v : this.parseNumber(v);
    if (!Number.isFinite(n)) return '';
    return n.toLocaleString('es-ES', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      useGrouping: false,
    });
  },
       toCsvDecimalComma(v, fixed = 2) {
    if (v === null || v === undefined || v === '') return '';
    let n = Number(v);
    if (Number.isNaN(n)) n = Number(String(v).replace(',', '.')); 
    if (Number.isNaN(n)) return '';
    return n.toLocaleString('es-ES', {
      minimumFractionDigits: fixed,
      maximumFractionDigits: fixed,
      useGrouping: false, 
    });
    },
      descargarDatos() {
        this.$emit("descargar-precios-omie");
      },
      //  Exportar datos a CSV asegurando el formato correcto
      exportToCSV() {
  const headers = HEADERS_OFICIALES_HIS.join(";");

  const rows = (this.precios_omie || []).map((row) => {
    const horizonte = this.convertirFecha(row.fecha_hora);
    const hora = row.hora ?? "";
    const precio = this.toCsvDecimalComma(row.valor, 2); // <- coma decimal
    return [horizonte, hora, precio].join(";");
  });

  const csvContent = [headers, ...rows].join("\n");
  const blob = new Blob(["\uFEFF" + csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "precios_historicos_OMIE.csv";
  a.click();
  URL.revokeObjectURL(url);
},

      //  Abrir el input de archivo CSV
      importFromCSV() {
        this.$refs.fileInput.click();
      },
      parseNumber(value) {
            if (!value) return 0;
            value = value.trim();

            if (value.includes(',') && !value.includes('.')) {
                value = value.replace(/\./g, '');        
                value = value.replace(',', '.');          
            }

            else if (value.includes(',') && value.includes('.')) {
                
                if (value.lastIndexOf(',') > value.lastIndexOf('.')) {
                value = value.replace(/\./g, '');       
                value = value.replace(',', '.');      
                }
                
                else {
                value = value.replace(/,/g, '');        
                }
            }
            return parseFloat(value);
            },

      // Procesar archivo CSV importado y actualizar la tabla
      handleUpload(event) {
  const file = event.target?.files?.[0];
  if (!file) return;

  // 1) Validación de extensión
  if (!/\.csv$/i.test(file.name)) {
    Swal.fire({ icon: "error", title: "Formato no válido", text: "Solo se admiten archivos .csv." });
    event.target.value = "";
    return;
  }

  const reader = new FileReader();
  reader.onload = (e) => {
    try {
      const data = e.target?.result ?? "";

      Papa.parse(data, {
        delimiter: ";",
        skipEmptyLines: true,
        header: true, // el CSV DEBE tener cabeceras
        complete: (result) => {
          // ====== Filas y cabeceras ======
          let rows = result.data || [];
          // elimina filas totalmente vacías
          rows = rows.filter(r => Object.values(r).some(v => String(v ?? "").trim() !== ""));
          if (!rows.length) throw new Error("El CSV está vacío.");

          // Cabeceras detectadas 
          let headers = (result.meta?.fields ?? Object.keys(rows[0] || []))
            .map((h, i) => (i === 0 ? String(h).replace(/^\uFEFF/, "") : String(h)).trim());

          // ====== Validación de CABECERAS  ======
          const faltantes = HEADERS_OFICIALES_HIS.filter(h => !headers.includes(h));
          const extrasRaw = headers.filter(h => !HEADERS_OFICIALES_HIS.includes(h));
          const extras = extrasRaw.map(x => String(x).trim()).filter(Boolean);

          const desordenadas = [];
          HEADERS_OFICIALES_HIS.forEach((h, i) => {
            if (headers[i] !== h) desordenadas.push(`${h} (posición esperada ${i + 1})`);
          });

          if (faltantes.length || extras.length || desordenadas.length) {
            const seccion = (titulo, arr) =>
              arr.length
                ? `<h4 style="margin:6px 0 2px 0;">${titulo}</h4>
                   <ul style="margin:0 0 8px 18px; padding:0;">${arr.map(x => `<li>${x}</li>`).join("")}</ul>`
                : "";

            const html =
              `<div style="text-align:left;">
                 <p>El CSV no respeta la <b>plantilla oficial</b> (encabezados y orden).</p>
                 ${seccion("❌ Faltan", faltantes)}
                 ${seccion("⚠️ Sobran", extras)}
                 ${seccion("🔄 Desordenadas", desordenadas)}
                 <p style="margin-top:6px;"><small>
                   Consejo: exporta la plantilla oficial y copia tus datos respetando los encabezados y su orden.
                 </small></p>
               </div>`;

            Swal.fire({ icon: "error", title: "Encabezados incorrectos", html, width: 800 });
            event.target.value = "";
            return; // salimos sin lanzar throw
          }
          // ====== Fin validación de CABECERAS ======

         
          // ====== Validación de celdas obligatorias por columna ======
          const COL_H = "Horizonte";
          const COL_HORA = "Hora";
          const COL_PRECIO = "Precio casación OMIE (€/MWh)";

          const faltasPorCol = { [COL_H]: [], [COL_HORA]: [], [COL_PRECIO]: [] };

          rows.forEach((r, idx) => {
            const line = idx + 2; 
            const h = String(r[COL_H] ?? "").trim();
            const hora = String(r[COL_HORA] ?? "").trim();
            const precioRaw = r[COL_PRECIO];

            if (!h) faltasPorCol[COL_H].push(line);
            if (!hora) faltasPorCol[COL_HORA].push(line);

            if (precioRaw === undefined || precioRaw === null || String(precioRaw).trim() === "") {
              faltasPorCol[COL_PRECIO].push(line);
            } else {
              const n = this.parseNumber(precioRaw);
              if (!Number.isFinite(n)) faltasPorCol[COL_PRECIO].push(line);
            }
          });

          const columnasConFaltas = Object.entries(faltasPorCol).filter(([, arr]) => arr.length > 0);
          if (columnasConFaltas.length) {
            const html =
              `<div style="text-align:left;">
                ${columnasConFaltas.map(([col, arr]) =>
                  `• <b>${col}</b>: líneas <b>${arr.join(", ")}</b>`
                ).join("<br>")}
               </div>`;
            Swal.fire({ icon: "error", title: "Faltan datos obligatorios", html });
            event.target.value = "";
            return;
          }

          // ====== Mapeo y actualización (negativos permitidos con aviso) ======
          const nuevosDatos = [...this.precios_omie];
          const missing = [];
          const negativos = [];

          rows.forEach((row) => {
            const horizonteCsv = this.convertirFecha(String(row[COL_H]).trim());
            const horaCsv = String(row[COL_HORA]).trim();
            const valorCsv = this.parseNumber(row[COL_PRECIO]);

            if (!Number.isFinite(valorCsv)) {
              throw new Error(`Valor no numérico en '${COL_PRECIO}' para ${row[COL_H]} ${horaCsv}.`);
            }

            if (valorCsv < 0) {
              negativos.push(`${row[COL_H]} ${horaCsv} = ${valorCsv}`);
            }

            const idx = nuevosDatos.findIndex(
              it => it.fecha_hora === horizonteCsv && String(it.hora).trim() === horaCsv
            );

            if (idx !== -1) {
              nuevosDatos[idx].valor = valorCsv; // interno con punto
            } else {
              missing.push(`${row[COL_H]} ${horaCsv}`);
            }
          });

          if (missing.length) {
            throw new Error(`Horizontes/horas no encontrados en la tabla: ${missing.slice(0, 5).join(", ")}${missing.length > 5 ? "…" : ""}`);
          }

          // Emitir cambios hacia el v-model
          this.$emit("update:precios_omie", nuevosDatos);

          
            Swal.fire({ icon: "success", title: "Importación correcta", text: `${rows.length} registros actualizados.` });
          
        },
        error: () => {
          throw new Error("No se pudo leer el CSV.");
        }
      });
    } catch (err) {
      Swal.fire({ icon: "error", title: "Error al importar", text: err?.message ?? "Archivo no válido." });
    } finally {
      event.target.value = ""; // reset input
    }
  };

  reader.readAsText(file, "utf-8");
},
      
     mostrarError(mensaje) {
  Swal.fire({ icon: 'error', title: 'Error', text: mensaje });
  console.error(mensaje);
},

      // Convertir fechas al formato estándar `YYYY-MM-DD HH:MM`
      convertirFecha(fecha) {
        if (!fecha) return "";

        const regexFormato1 = /^(\d{2})\/(\d{2})\/(\d{4}) (\d{1,2}):(\d{2})$/; // DD/MM/YYYY HH:MM
        const regexFormato2 = /^(\d{4})-(\d{2})-(\d{2}) (\d{1,2}):(\d{2})$/; // YYYY-MM-DD HH:MM

        if (regexFormato1.test(fecha)) {
          const [, day, month, year, hours, minutes] = fecha.match(regexFormato1);
          return `${year}-${month}-${day} ${hours.padStart(2, "0")}:${minutes}`;
        } else if (regexFormato2.test(fecha)) {
          return fecha; 
        }

        // Convertir si viene en otro formato raro
        let fechaObj = new Date(fecha);
        if (isNaN(fechaObj.getTime())) {
          console.warn("Formato de fecha incorrecto en importación:", fecha);
          return fecha;
        }

        let year = fechaObj.getFullYear();
        let month = (fechaObj.getMonth() + 1).toString().padStart(2, "0");
        let day = fechaObj.getDate().toString().padStart(2, "0");
        let hours = fechaObj.getHours().toString().padStart(2, "0");
        let minutes = fechaObj.getMinutes().toString().padStart(2, "0");

        return `${year}-${month}-${day} ${hours}:${minutes}`;
      }
    }
  };
</script>
  
  
  <style scoped>
  .scroll-container {
  width: 100%;
  height: 100%;
  max-height: calc(100vh - 200px); 
  overflow-x: auto;
  overflow-y: auto;
  /* border: 1px solid #D9D9D9; */
  border-radius: 10px;
  display: flex;
  flex-direction: column;
}
.contenedor-tabla {
  max-width: 600px;
 /*  margin: auto; */
}

  
  table {
    width: 100%;
    border-collapse: collapse;
    text-align: center;
  }
  thead {
    position: sticky;
    top: 0;
    background-color: white;
    z-index: 10;
  }
  
  .table-header {
    position: sticky;
    top: 0;
    z-index: 15;
    font-size: 1.5em;
    font-weight: bold;
    text-align: center;
    margin-bottom: 10px;
    color: white;
    background-color: #006699;
    padding: 10px;
  }
  
/*   th {
    border: 2px solid #D9D9D9;
    background-color: white;
    color: #024e74;
    padding: 10px;
    font-weight: bold;
    font-size: large;
  } */
  
  .primera_columna {
    background-color: white;
  }
  
/*   td {
    font-weight: bold;
    color: #024e74;
    border: 2px solid #D9D9D9;
    padding: 10px;
    background-color: #F2F2F2;
  } */
  
  input[disabled] {
    background-color: white;
    color: #024e74;
    cursor: not-allowed;
  }

  .encabezado_bold{
  font-size: 14px;
}
  </style>
  
  